import Logger from '@lib/Logger';
import {MediaQuery} from '@services/MediaQuery';
import {MediaQueryScreenMode} from '@services/types';

// window.preloadsのjsonからpreload用の画像URLを取得する
// desktop, phoneはmediaQueryのscreenModeに依存している
// window.preloads = {
//   image1: {desktop: 'http://hoge/foo.jpg', phone: 'http://hoge/foo.jpg'},
//   image2: {desktop: 'http://hoge/foo.jpg', phone: 'http://hoge/foo.jpg'},
// };
export const getPreloadUrls = () => {
  const mq = MediaQuery.create();
  const preloads = window.preloads || {};
  return Object.values(preloads)
    .map((preload) => {
      if (!Object.prototype.hasOwnProperty.call(preload, mq.mode!)) {
        Logger.assert('window.preload is incorrect.');
      }
      return (preload as Record<MediaQueryScreenMode, string>)[mq.mode!];
    })
    .filter((url) => !!url);
};

export const domLoaded = () =>
  new Promise<void>((resolve) => {
    if (document.readyState !== 'loading') {
      Logger.log('domLoaded() -> document.readyState: ' + document.readyState);
      setTimeout(() => resolve(), 0);
      return;
    }
    window.addEventListener('load', function () {
      Logger.log('domLoaded() -> window.load');
      resolve();
    });
    document.addEventListener('DOMContentLoaded', function () {
      Logger.log('domLoaded() -> DOMContentLoaded');
      resolve();
    });
  });
